var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentItem',{attrs:{"name":_vm.name}},[_c('TabOrder',{on:{"order":(value)=>_vm.$emit('order',value)},model:{value:(_vm.settingInfo.tabOrder),callback:function ($$v) {_vm.$set(_vm.settingInfo, "tabOrder", $$v)},expression:"settingInfo.tabOrder"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }